import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { failedResponses } from '../../errors/responses';

const c = initContract();

export const AdditionalStock = z.object({
  stockLevelId: z.string(),
  catalogItemId: z.string(),
  minimumStockLevel: z.number(),
  maximumStockLevel: z.number()
});

export type AdditionalStock = z.infer<typeof AdditionalStock>;

const AdditionalStockRequest = z.array(
  z.object({
    catalogItemId: z.string(),
    minimumStockLevel: z.number(),
    maximumStockLevel: z.number()
  })
);

export default c.router({
  upsertAdditionalBundleStock: {
    method: 'PUT',
    path: '/msp/:mspId/customers/:customerId/stocklevels/:stockLevelId/additionalBundleStocks',
    responses: {
      200: AdditionalStock,
      ...failedResponses
    },
    body: AdditionalStockRequest
  },
  upsertAdditionalGeneralStock: {
    method: 'PUT',
    path: '/msp/:mspId/customers/:customerId/stocklevels/:stockLevelId/additionalGeneralStocks',
    responses: {
      200: AdditionalStock,
      ...failedResponses
    },
    body: AdditionalStockRequest
  }
});
